import { ReportsPage } from "./ReportsPage";

export default ReportsPage;
